var map = {
	"./air-nga-en/assets/background.png": 92322,
	"./ais-tai-en/assets/background.png": 36461,
	"./ais-tai-tha/assets/background.png": 73785,
	"./demo-arabic/assets/background.png": 85889,
	"./demo-et-en/assets/background.png": 11014,
	"./demo-romanian/assets/background.png": 2140,
	"./demo-um-en/assets/background.png": 43425,
	"./dtac-tai-en/assets/background.png": 12636,
	"./dtac-tai-tha/assets/background.png": 57834,
	"./ethiotel-et-amh/assets/background.png": 90344,
	"./ethiotel-et-en/assets/background.png": 94463,
	"./mtn-cg-fr/assets/background.png": 15552,
	"./mtn-ci-fr/assets/background.png": 21530,
	"./mtn-cmr-fr/assets/background.png": 48190,
	"./mtn-gha-en/assets/background.png": 12375,
	"./mtn-nga-en/assets/background.png": 1851,
	"./mtn-zam-en/assets/background.png": 66497,
	"./saf-ke-en/assets/background.png": 55182,
	"./saudi-uae-en/assets/background.png": 27729,
	"./tlk-za-en/assets/background.png": 15970,
	"./vc-za-en/assets/background.png": 5598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98720;